import { Component, Input, Output, EventEmitter } from '@angular/core';

export type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'primary' | 'secondary' | 'outline';
export type BadgeSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() label: string = '';
  @Input() variant: BadgeVariant = 'primary';
  @Input() size: BadgeSize = 'medium';
  @Input() icon: string = '';
  @Input() closeable: boolean = false;
  @Input() isDot: boolean = false;
  @Input() count: number = 0;
  @Input() pillShape: boolean = false;

  @Output() close = new EventEmitter<void>();

  onClose(event: Event): void {
    event.stopPropagation();
    this.close.emit();
  }

  getBadgeClasses(): string {
    const classes = ['badge'];
    if (this.variant) classes.push(`variant-${this.variant}`);
    if (this.size) classes.push(`size-${this.size}`);
    if (this.closeable) classes.push('closeable');
    if (this.isDot) classes.push('is-dot');
    if (this.pillShape) classes.push('pill-shape');
    return classes.join(' ');
  }

  getDisplayText(): string {
    if (this.count > 0) {
      return this.count > 99 ? '99+' : this.count.toString();
    }
    return this.label;
  }

  shouldShowLabel(): boolean {
    return !this.isDot && (!!this.label || this.count > 0);
  }
}
